import NotificationsPanel from "../../components/NotificationsPanel";
import { useAuth } from "../../context/AuthContext";

export default function NotificationsPage() {
  const { user } = useAuth();

  return (
    <div className="p-4 pt-20">
      <h1 className="text-xl font-bold mb-4 text-gray-700">Notifications</h1>
      <NotificationsPanel userId={user?.email} />
    </div>
  );
}
